/**
 * Gjestens rettigheter, slik sidene omtaler dem.
 *
 * Speiling av `apps/api/src/shared/gjesterettigheter.ts`, som er den e-postene
 * og endepunktene regner med, og der begrunnelsen står.
 */

/** Timer bekreftelseslenka for en sletting virker. */
export const SLETTEFRIST_TIMER = 24;

/** Stien til rettighetssida, under gjestens egen svarlenke. */
export const RETTIGHETER_STI = (token: string) => `/rsvp/${token}/personvern`;
